export default __webpack_public_path__ + "static/media/86f60b798661fc1a05258b0950594be8.svg";